export default {
  updatePlano (state, data) {
    state.plano = data
  },
  updateFaturas (state, data) {
    state.faturas = data
  },

}
